export const MAX_INVOICE_SELECTION = 100;
export const MAX_STATEMENT_SELECTION = 500;
export const INITIAL_TOAST_ERROR_MESSAGE = 'initialToastErrorMessage';
export const OPEN_AUTOPAY_MODAL = 'openAutoPayModel';
